import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AutosizeModule } from 'ngx-autosize';

import { InvitationEditorComponent } from './invitation-editor.component';

@NgModule({
  declarations: [InvitationEditorComponent],
  exports: [InvitationEditorComponent],
  imports: [CommonModule, AutosizeModule, FormsModule],
})
export class InvitationEditorModule {}
